import { useAppSelector } from '@web-common/state/createStore';
import { FLOLDER } from './../common/constant';
import { folderIdIsAllFolder } from '@web-mail/util';
const useShouldUseRealList = () => {
    const useRealList = useAppSelector(state => {
        var _a;
        if (!!state.mailReducer.mailSearching) {
            return state.mailReducer.useRealList;
        }
        else {
            const notSupportFids = [FLOLDER.TASK, FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW];
            return (!folderIdIsAllFolder((_a = state.mailReducer.selectedKeys) === null || _a === void 0 ? void 0 : _a.id) && state.mailReducer.useRealList && !notSupportFids.some(fid => fid == state.mailReducer.selectedKeys.id));
        }
    });
    return useRealList;
};
export default useShouldUseRealList;
